import { computed } from "vue";
import { useBookingWidgetStore } from "../stores";
import { useTurnstile } from "./useTurnstile";
export function useBookingWidget() {
    const store = useBookingWidgetStore();
    const { getAssessment } = useTurnstile();
    // Obtains a fresh Turnstile assessment (when the configured root requires
    // one) immediately before intent creation, per the contract — the token is
    // only ever attached to the intent request, never the final booking.
    async function createIntent(proposal) {
        const config = store.config;
        if (!config)
            throw new Error("Booking widget is not configured");
        const captchaToken = config.captchaRequired && config.turnstileSiteKey
            ? await getAssessment(config.turnstileSiteKey, "booking_intent")
            : "";
        return store.startIntent(proposal, captchaToken);
    }
    return {
        catalog: computed(() => store.catalog),
        availability: computed(() => store.availability),
        reviews: computed(() => store.reviews),
        intent: computed(() => store.intent),
        bookingResult: computed(() => store.bookingResult),
        isLoading: computed(() => store.isLoading),
        isIntentInFlight: computed(() => store.isIntentInFlight),
        isConfirming: computed(() => store.isConfirming),
        error: computed(() => store.error),
        lastErrorStatus: computed(() => store.lastErrorStatus),
        retryAfterSeconds: computed(() => store.retryAfterSeconds),
        configure: (config) => store.configure(config),
        loadCatalog: () => store.loadCatalog(),
        loadAvailability: (serviceId, params) => store.loadAvailability(serviceId, params),
        loadReviews: (serviceId, params) => store.loadReviews(serviceId, params),
        createIntent,
        confirmBooking: () => store.confirmBooking(),
        clearIntent: () => store.clearIntent(),
    };
}
